// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/__root'
import { Route as DashboardRouteImport } from './app/dashboard'
import { Route as AdminRouteImport } from './app/admin'
import { Route as IndexRouteImport } from './app/index'
import { Route as ShareTokenRouteImport } from './app/share.$token'
import { Route as authResetPasswordRouteImport } from './app/(auth)/reset-password'
import { Route as authLoginRouteImport } from './app/(auth)/login'
import { Route as authForgotPasswordRouteImport } from './app/(auth)/forgot-password'
import { Route as DashboardIndexRouteImport } from './app/dashboard/index'
import { Route as AdminIndexRouteImport } from './app/admin/index'
import { Route as DashboardVehiclesIndexRouteImport } from './app/dashboard/vehicles/index'
import { Route as DashboardTasksIndexRouteImport } from './app/dashboard/tasks/index'
import { Route as DashboardTachographActivitiesIndexRouteImport } from './app/dashboard/tachograph-activities/index'
import { Route as DashboardRoutesIndexRouteImport } from './app/dashboard/routes/index'
import { Route as DashboardReportsIndexRouteImport } from './app/dashboard/reports/index'
import { Route as DashboardNotificationsIndexRouteImport } from './app/dashboard/notifications/index'
import { Route as DashboardMessagesIndexRouteImport } from './app/dashboard/messages/index'
import { Route as DashboardFuelAnomalyIndexRouteImport } from './app/dashboard/fuel-anomaly/index'
import { Route as DashboardFleetMapIndexRouteImport } from './app/dashboard/fleet-map/index'
import { Route as DashboardEcoDrivingIndexRouteImport } from './app/dashboard/eco-driving/index'
import { Route as DashboardDriversIndexRouteImport } from './app/dashboard/drivers/index'
import { Route as DashboardDocumentsIndexRouteImport } from './app/dashboard/documents/index'
import { Route as DashboardDevicesIndexRouteImport } from './app/dashboard/devices/index'
import { Route as DashboardComplianceIndexRouteImport } from './app/dashboard/compliance/index'
import { Route as DashboardCalculateRouteIndexRouteImport } from './app/dashboard/calculate-route/index'
import { Route as DashboardVehiclesCreateRouteImport } from './app/dashboard/vehicles/create'
import { Route as DashboardTachographActivitiesVehicleIdRouteImport } from './app/dashboard/tachograph-activities/$vehicleId'
import { Route as DashboardRoutesCreateRouteImport } from './app/dashboard/routes/create'
import { Route as DashboardDriversCreateRouteImport } from './app/dashboard/drivers/create'
import { Route as AdminUsersIndexRouteImport } from './app/admin/users/index'
import { Route as AdminOrganizationsIndexRouteImport } from './app/admin/organizations/index'
import { Route as AdminFeedbackIndexRouteImport } from './app/admin/feedback/index'
import { Route as AdminDevicesIndexRouteImport } from './app/admin/devices/index'
import { Route as AdminUsersCreateRouteImport } from './app/admin/users/create'
import { Route as AdminOrganizationsCreateRouteImport } from './app/admin/organizations/create'
import { Route as AdminDevicesCreateRouteImport } from './app/admin/devices/create'
import { Route as DashboardVehiclesVehicleIdIndexRouteImport } from './app/dashboard/vehicles/$vehicleId/index'
import { Route as DashboardVehiclesVehicleIdEditRouteImport } from './app/dashboard/vehicles/$vehicleId/edit'
import { Route as DashboardTachographActivitiesDriverDriverIdRouteImport } from './app/dashboard/tachograph-activities/driver/$driverId'
import { Route as DashboardDriversDriverIdEditRouteImport } from './app/dashboard/drivers/$driverId/edit'
import { Route as AdminOrganizationsOrgIdIndexRouteImport } from './app/admin/organizations/$orgId/index'
import { Route as AdminUsersUserIdEditRouteImport } from './app/admin/users/$userId/edit'
import { Route as AdminOrganizationsOrgIdEditRouteImport } from './app/admin/organizations/$orgId/edit'
import { Route as AdminDevicesDeviceIdEditRouteImport } from './app/admin/devices/$deviceId/edit'
import { Route as DashboardTachographActivitiesViewerTypeFileIdRouteImport } from './app/dashboard/tachograph-activities/viewer/$type.$fileId'

const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ShareTokenRoute = ShareTokenRouteImport.update({
            id: '/share/$token',path: '/share/$token',getParentRoute: () => rootRouteImport
          })
const authResetPasswordRoute = authResetPasswordRouteImport.update({
            id: '/(auth)/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const authLoginRoute = authLoginRouteImport.update({
            id: '/(auth)/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
            id: '/(auth)/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const DashboardVehiclesIndexRoute = DashboardVehiclesIndexRouteImport.update({
            id: '/vehicles/',path: '/vehicles/',getParentRoute: () => DashboardRoute
          })
const DashboardTasksIndexRoute = DashboardTasksIndexRouteImport.update({
            id: '/tasks/',path: '/tasks/',getParentRoute: () => DashboardRoute
          })
const DashboardTachographActivitiesIndexRoute = DashboardTachographActivitiesIndexRouteImport.update({
            id: '/tachograph-activities/',path: '/tachograph-activities/',getParentRoute: () => DashboardRoute
          })
const DashboardRoutesIndexRoute = DashboardRoutesIndexRouteImport.update({
            id: '/routes/',path: '/routes/',getParentRoute: () => DashboardRoute
          })
const DashboardReportsIndexRoute = DashboardReportsIndexRouteImport.update({
            id: '/reports/',path: '/reports/',getParentRoute: () => DashboardRoute
          })
const DashboardNotificationsIndexRoute = DashboardNotificationsIndexRouteImport.update({
            id: '/notifications/',path: '/notifications/',getParentRoute: () => DashboardRoute
          })
const DashboardMessagesIndexRoute = DashboardMessagesIndexRouteImport.update({
            id: '/messages/',path: '/messages/',getParentRoute: () => DashboardRoute
          })
const DashboardFuelAnomalyIndexRoute = DashboardFuelAnomalyIndexRouteImport.update({
            id: '/fuel-anomaly/',path: '/fuel-anomaly/',getParentRoute: () => DashboardRoute
          })
const DashboardFleetMapIndexRoute = DashboardFleetMapIndexRouteImport.update({
            id: '/fleet-map/',path: '/fleet-map/',getParentRoute: () => DashboardRoute
          })
const DashboardEcoDrivingIndexRoute = DashboardEcoDrivingIndexRouteImport.update({
            id: '/eco-driving/',path: '/eco-driving/',getParentRoute: () => DashboardRoute
          })
const DashboardDriversIndexRoute = DashboardDriversIndexRouteImport.update({
            id: '/drivers/',path: '/drivers/',getParentRoute: () => DashboardRoute
          })
const DashboardDocumentsIndexRoute = DashboardDocumentsIndexRouteImport.update({
            id: '/documents/',path: '/documents/',getParentRoute: () => DashboardRoute
          })
const DashboardDevicesIndexRoute = DashboardDevicesIndexRouteImport.update({
            id: '/devices/',path: '/devices/',getParentRoute: () => DashboardRoute
          })
const DashboardComplianceIndexRoute = DashboardComplianceIndexRouteImport.update({
            id: '/compliance/',path: '/compliance/',getParentRoute: () => DashboardRoute
          })
const DashboardCalculateRouteIndexRoute = DashboardCalculateRouteIndexRouteImport.update({
            id: '/calculate-route/',path: '/calculate-route/',getParentRoute: () => DashboardRoute
          })
const DashboardVehiclesCreateRoute = DashboardVehiclesCreateRouteImport.update({
            id: '/vehicles/create',path: '/vehicles/create',getParentRoute: () => DashboardRoute
          })
const DashboardTachographActivitiesVehicleIdRoute = DashboardTachographActivitiesVehicleIdRouteImport.update({
            id: '/tachograph-activities/$vehicleId',path: '/tachograph-activities/$vehicleId',getParentRoute: () => DashboardRoute
          })
const DashboardRoutesCreateRoute = DashboardRoutesCreateRouteImport.update({
            id: '/routes/create',path: '/routes/create',getParentRoute: () => DashboardRoute
          })
const DashboardDriversCreateRoute = DashboardDriversCreateRouteImport.update({
            id: '/drivers/create',path: '/drivers/create',getParentRoute: () => DashboardRoute
          })
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
            id: '/users/',path: '/users/',getParentRoute: () => AdminRoute
          })
const AdminOrganizationsIndexRoute = AdminOrganizationsIndexRouteImport.update({
            id: '/organizations/',path: '/organizations/',getParentRoute: () => AdminRoute
          })
const AdminFeedbackIndexRoute = AdminFeedbackIndexRouteImport.update({
            id: '/feedback/',path: '/feedback/',getParentRoute: () => AdminRoute
          })
const AdminDevicesIndexRoute = AdminDevicesIndexRouteImport.update({
            id: '/devices/',path: '/devices/',getParentRoute: () => AdminRoute
          })
const AdminUsersCreateRoute = AdminUsersCreateRouteImport.update({
            id: '/users/create',path: '/users/create',getParentRoute: () => AdminRoute
          })
const AdminOrganizationsCreateRoute = AdminOrganizationsCreateRouteImport.update({
            id: '/organizations/create',path: '/organizations/create',getParentRoute: () => AdminRoute
          })
const AdminDevicesCreateRoute = AdminDevicesCreateRouteImport.update({
            id: '/devices/create',path: '/devices/create',getParentRoute: () => AdminRoute
          })
const DashboardVehiclesVehicleIdIndexRoute = DashboardVehiclesVehicleIdIndexRouteImport.update({
            id: '/vehicles/$vehicleId/',path: '/vehicles/$vehicleId/',getParentRoute: () => DashboardRoute
          })
const DashboardVehiclesVehicleIdEditRoute = DashboardVehiclesVehicleIdEditRouteImport.update({
            id: '/vehicles/$vehicleId/edit',path: '/vehicles/$vehicleId/edit',getParentRoute: () => DashboardRoute
          })
const DashboardTachographActivitiesDriverDriverIdRoute = DashboardTachographActivitiesDriverDriverIdRouteImport.update({
            id: '/tachograph-activities/driver/$driverId',path: '/tachograph-activities/driver/$driverId',getParentRoute: () => DashboardRoute
          })
const DashboardDriversDriverIdEditRoute = DashboardDriversDriverIdEditRouteImport.update({
            id: '/drivers/$driverId/edit',path: '/drivers/$driverId/edit',getParentRoute: () => DashboardRoute
          })
const AdminOrganizationsOrgIdIndexRoute = AdminOrganizationsOrgIdIndexRouteImport.update({
            id: '/organizations/$orgId/',path: '/organizations/$orgId/',getParentRoute: () => AdminRoute
          })
const AdminUsersUserIdEditRoute = AdminUsersUserIdEditRouteImport.update({
            id: '/users/$userId/edit',path: '/users/$userId/edit',getParentRoute: () => AdminRoute
          })
const AdminOrganizationsOrgIdEditRoute = AdminOrganizationsOrgIdEditRouteImport.update({
            id: '/organizations/$orgId/edit',path: '/organizations/$orgId/edit',getParentRoute: () => AdminRoute
          })
const AdminDevicesDeviceIdEditRoute = AdminDevicesDeviceIdEditRouteImport.update({
            id: '/devices/$deviceId/edit',path: '/devices/$deviceId/edit',getParentRoute: () => AdminRoute
          })
const DashboardTachographActivitiesViewerTypeFileIdRoute = DashboardTachographActivitiesViewerTypeFileIdRouteImport.update({
            id: '/tachograph-activities/viewer/$type/$fileId',path: '/tachograph-activities/viewer/$type/$fileId',getParentRoute: () => DashboardRoute
          })





const AdminRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,AdminDevicesCreateRoute: AdminDevicesCreateRoute,AdminOrganizationsCreateRoute: AdminOrganizationsCreateRoute,AdminUsersCreateRoute: AdminUsersCreateRoute,AdminDevicesIndexRoute: AdminDevicesIndexRoute,AdminFeedbackIndexRoute: AdminFeedbackIndexRoute,AdminOrganizationsIndexRoute: AdminOrganizationsIndexRoute,AdminUsersIndexRoute: AdminUsersIndexRoute,AdminDevicesDeviceIdEditRoute: AdminDevicesDeviceIdEditRoute,AdminOrganizationsOrgIdEditRoute: AdminOrganizationsOrgIdEditRoute,AdminUsersUserIdEditRoute: AdminUsersUserIdEditRoute,AdminOrganizationsOrgIdIndexRoute: AdminOrganizationsOrgIdIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const DashboardRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,DashboardDriversCreateRoute: DashboardDriversCreateRoute,DashboardRoutesCreateRoute: DashboardRoutesCreateRoute,DashboardTachographActivitiesVehicleIdRoute: DashboardTachographActivitiesVehicleIdRoute,DashboardVehiclesCreateRoute: DashboardVehiclesCreateRoute,DashboardCalculateRouteIndexRoute: DashboardCalculateRouteIndexRoute,DashboardComplianceIndexRoute: DashboardComplianceIndexRoute,DashboardDevicesIndexRoute: DashboardDevicesIndexRoute,DashboardDocumentsIndexRoute: DashboardDocumentsIndexRoute,DashboardDriversIndexRoute: DashboardDriversIndexRoute,DashboardEcoDrivingIndexRoute: DashboardEcoDrivingIndexRoute,DashboardFleetMapIndexRoute: DashboardFleetMapIndexRoute,DashboardFuelAnomalyIndexRoute: DashboardFuelAnomalyIndexRoute,DashboardMessagesIndexRoute: DashboardMessagesIndexRoute,DashboardNotificationsIndexRoute: DashboardNotificationsIndexRoute,DashboardReportsIndexRoute: DashboardReportsIndexRoute,DashboardRoutesIndexRoute: DashboardRoutesIndexRoute,DashboardTachographActivitiesIndexRoute: DashboardTachographActivitiesIndexRoute,DashboardTasksIndexRoute: DashboardTasksIndexRoute,DashboardVehiclesIndexRoute: DashboardVehiclesIndexRoute,DashboardDriversDriverIdEditRoute: DashboardDriversDriverIdEditRoute,DashboardTachographActivitiesDriverDriverIdRoute: DashboardTachographActivitiesDriverDriverIdRoute,DashboardVehiclesVehicleIdEditRoute: DashboardVehiclesVehicleIdEditRoute,DashboardVehiclesVehicleIdIndexRoute: DashboardVehiclesVehicleIdIndexRoute,DashboardTachographActivitiesViewerTypeFileIdRoute: DashboardTachographActivitiesViewerTypeFileIdRoute
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,DashboardRoute: DashboardRouteWithChildren,authForgotPasswordRoute: authForgotPasswordRoute,authLoginRoute: authLoginRoute,authResetPasswordRoute: authResetPasswordRoute,ShareTokenRoute: ShareTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)